import { render, staticRenderFns } from "./CesShopGoodsForm.vue?vue&type=template&id=66364030"
import script from "./CesShopGoodsForm.vue?vue&type=script&lang=js"
export * from "./CesShopGoodsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports